<style lang="scss" scoped>
</style>

<template>
  <div>
    <div class="clearfix mb20">
      <el-radio-group v-model="type" @change="router">
        <el-radio-button :label="`/third/${id}/pay/index`">微信支付收银台</el-radio-button>
        <el-radio-button :label="`/third/${id}/pay/config`">微信支付配置</el-radio-button>
      </el-radio-group>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {},
  props: ['id'],
  data() {
    return {
      type: this.$route.path,
    };
  },
  mounted() {},
  methods: {
    router() {
      this.$router.push(this.type);
    },
  },
};
</script>
